import React from 'react';
import { Divider, Breakpoint } from '@moda/om';
import { noop, useFeatureFlag } from '@moda/portal-stanchions';
import { SignIn } from './SignIn';
import { Guest } from './Guest';
import { CheckoutSocialAuthButtons } from './CheckoutSocialAuthButtons';

import './Authentication.scss';
import './CheckoutAuthentication.scss';

interface Props {
  changePayment: () => void;
}

export const CheckoutAuthentication: React.FC<Props> = ({ changePayment }) => {
  const guestCheckoutAsPrimary = useFeatureFlag('show-guest-checkout-as-primary', [
    { default: false },
    { if: true, then: true }
  ]);

  return (
    <div className="CheckoutAuthentication">
      {guestCheckoutAsPrimary && (
        <>
          <div className="CheckoutAuthentication__section">
            <Guest onAuth={noop} />
            <Breakpoint lt="sm">
              <Divider />
            </Breakpoint>
          </div>
          <div className="CheckoutAuthentication__section">
            <SignIn
              title="Returning Customers"
              message="Please sign in for a quicker checkout experience."
              showSocialAuth={false}
              onAuth={noop}
              changePayment={changePayment}
            />
            <CheckoutSocialAuthButtons />
          </div>
        </>
      )}

      {guestCheckoutAsPrimary === false && (
        <>
          <div className="CheckoutAuthentication__section">
            <SignIn
              title="Returning Customers"
              message="Please sign in for a quicker checkout experience."
              showSocialAuth={false}
              onAuth={noop}
              changePayment={changePayment}
            />
            <Breakpoint gt="sm">
              <CheckoutSocialAuthButtons />
            </Breakpoint>
            <Breakpoint lt="sm">
              <Divider />
            </Breakpoint>
          </div>
          <div className="CheckoutAuthentication__section">
            <Guest onAuth={noop} />
          </div>
          <Breakpoint lt="sm">
            <CheckoutSocialAuthButtons />
          </Breakpoint>
        </>
      )}
    </div>
  );
};
